import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import { EXTRAS } from 'utils/constants/jobDetails';

const LoadDetails = ({ className, numberOfItems, mass, height, extras }) => {
  const { t } = useTranslation('Offers');
  return (
    <div className={className} data-testid="load-details">
      <div className="load-details">
        <div className="load-details__palletes">{`${numberOfItems} Eu`}</div>
        <div className="load-details__mass">{`${mass} Kg`}</div>
        <div className="load-details__height">{`${height / 100} m`}</div>
        <div className="load-details__extras-container">
          {extras.includes(EXTRAS.LIFTGATE) && (
            <div
              className="load-details__extra-icon"
              title={t('LIFTGATE')}
              data-testid="load-details__liftgate"
            >
              <Icon glyph="extras-liftgate" size="1rem" />
            </div>
          )}
          {extras.includes(EXTRAS.SIDE_LOAD) && (
            <div
              className="load-details__extra-icon"
              title={t('SIDE_LOAD')}
              data-testid="load-details__sideload"
            >
              <Icon glyph="extras-sideload" size="1rem" />
            </div>
          )}
          {extras.includes(EXTRAS.TOP_LOAD) && (
            <div
              className="load-details__extra-icon"
              title={t('retractableRoof')}
              data-testid="load-details__topload"
            >
              <Icon glyph="extras-retractableroof" size="1rem" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

LoadDetails.defaultProps = {
  mass: 0,
  height: 0,
  extras: [],
  bottomAlign: false,
};

LoadDetails.propTypes = {
  numberOfItems: PropTypes.number.isRequired,
  mass: PropTypes.number,
  height: PropTypes.number,
  extras: PropTypes.array,
  bottomAlign: PropTypes.bool,
};

export default LoadDetails;
